/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Publish_Now_ButtonInputs */

const en_iconik_publish_now_button = /** @type {(inputs: Iconik_Publish_Now_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publish Now`)
};

const fr_iconik_publish_now_button = /** @type {(inputs: Iconik_Publish_Now_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publier maintenant`)
};

const de_iconik_publish_now_button = /** @type {(inputs: Iconik_Publish_Now_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jetzt veröffentlichen`)
};

const it_iconik_publish_now_button = /** @type {(inputs: Iconik_Publish_Now_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pubblica ora`)
};

const ru_iconik_publish_now_button = /** @type {(inputs: Iconik_Publish_Now_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Опубликовать сейчас`)
};

const es_iconik_publish_now_button = /** @type {(inputs: Iconik_Publish_Now_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publicar ahora`)
};

const zh_cn2_iconik_publish_now_button = /** @type {(inputs: Iconik_Publish_Now_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`立即发布`)
};

const ja_iconik_publish_now_button = /** @type {(inputs: Iconik_Publish_Now_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`今すぐ公開`)
};

const hi_iconik_publish_now_button = /** @type {(inputs: Iconik_Publish_Now_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अब प्रकाशित करें`)
};

const pt_pt2_iconik_publish_now_button = /** @type {(inputs: Iconik_Publish_Now_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publicar agora`)
};

/**
* | output |
* | --- |
* | "Publish Now" |
*
* @param {Iconik_Publish_Now_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_publish_now_button = /** @type {((inputs?: Iconik_Publish_Now_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Publish_Now_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iconik_publish_now_button(inputs)
	if (locale === "de") return de_iconik_publish_now_button(inputs)
	if (locale === "it") return it_iconik_publish_now_button(inputs)
	if (locale === "ru") return ru_iconik_publish_now_button(inputs)
	if (locale === "es") return es_iconik_publish_now_button(inputs)
	if (locale === "zh-CN") return zh_cn2_iconik_publish_now_button(inputs)
	if (locale === "ja") return ja_iconik_publish_now_button(inputs)
	if (locale === "hi") return hi_iconik_publish_now_button(inputs)
	if (locale === "pt-PT") return pt_pt2_iconik_publish_now_button(inputs)
	return en_iconik_publish_now_button(inputs)
});